/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import FadeIn from "../../common/FadeIn";
import StatusBlock from "../../common/StatusBlock";
//Bootstrap
import { Form, Col, Row, Button } from "react-bootstrap";
//Images and Icons
import { MdSave, MdOutlineCancel } from "react-icons/md";

const EditYourInfo = (props) => {
  const customer = props.customer;
  const [First_Name, setFirst_Name] = useState(customer.First_Name);
  const [Last_Name, setLast_Name] = useState(customer.Last_Name);
  const [Postcode, setPostcode] = useState(customer.Postcode);
  const [Street_Address, setStreet_Address] = useState(customer.Street_Address);
  const [City, setCity] = useState(customer.City);
  const [Contact_Number, setContact_Number] = useState(customer.Contact_Number);
  const [heardAbout, setHeardAbout] = useState(customer.heardAbout);
  const [marketingConsent, setMarketingConsent] = useState(customer.marketingConsent);

  const currentKey = props.updateKey;

  const capitalize = (string) => {
    return string.charAt(0, 1).toUpperCase() + string.slice(1, string.length);
  };

  const editCustomer = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const data = {
      First_Name: First_Name.trim(),
      Last_Name: Last_Name.trim(),
      Contact_Number: Contact_Number.trim(),
      Street_Address: Street_Address.trim(),
      City: City.trim(),
      Postcode: Postcode.trim(),
      heardAbout: heardAbout,
      marketingConsent: marketingConsent,
    };

    const editCustomerRequest = await axios.put(
      `/api/customer/manage_customer/edit_customer`,
      data,
      {
        withCredentials: true,
      }
    );
    if (editCustomerRequest.status === 200) {
      props.setViewMode("view");
      props.setSubmitClicked(false);
      return props.setUpdateKey(currentKey + 1);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was an error - please contact support if it");
    }
  };

  return (
    <FadeIn delay={250} duration={450}>
      <Row>
        <Col>
          <div className='text-center mt-2 mb-2'>
            <Button variant='secondary' onClick={() => props.setViewMode("view")}>
              <MdOutlineCancel />
              Return
            </Button>
          </div>
          <Form className='shadow p-4 mx-auto' onSubmit={editCustomer}>
            <Row>
              <Col sm='12' lg='4'>
                <Form.Group controlId='FirstNamesForm'>
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='256'
                    value={First_Name}
                    onChange={(e) => setFirst_Name(capitalize(e.target.value))}
                    required
                    className='border'
                  />
                </Form.Group>
              </Col>
              <Col sm='12' lg='4'>
                <Form.Group controlId='LastNamesForm'>
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='256'
                    value={Last_Name}
                    onChange={(e) => setLast_Name(capitalize(e.target.value))}
                    required
                    className='border'
                  />
                </Form.Group>
              </Col>
              <Col sm='12' lg='4'>
                <Form.Group controlId='Contact No'>
                  <Form.Label>Contact Number</Form.Label>
                  <Form.Control
                    type='tel'
                    pattern='^[0-9 ]{1,15}$'
                    value={Contact_Number}
                    onChange={(e) => setContact_Number(e.target.value)}
                    required
                    className='border'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm='12' lg='12'>
                <Form.Group controlId='Adress1Form'>
                  <Form.Label>Street Address</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='256'
                    value={Street_Address}
                    onChange={(e) => setStreet_Address(e.target.value)}
                    required
                    className='border'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm='12' lg='6'>
                <Form.Group controlId='Adress2Form'>
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='256'
                    value={City}
                    onChange={(e) => setCity(e.target.value)}
                    required
                    className='border'
                  />
                </Form.Group>
              </Col>

              <Col sm='12' lg='6'>
                <Form.Group controlId='EndTimeForm'>
                  <Form.Label>Postcode/ZIP</Form.Label>
                  <Form.Control
                    type='text'
                    maxLength='256'
                    pattern='^[0-9 a-zA-Z]{1,10}$'
                    value={Postcode}
                    onChange={(e) => setPostcode(e.target.value)}
                    required
                    className='border'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm='12' lg='6'>
                <Form.Group controlId='EndTimeForm'>
                  <Form.Label>How did you hear about us?</Form.Label>
                  <Form.Control
                    as='select'
                    value={heardAbout}
                    onChange={(e) => setHeardAbout(e.target.value)}
                    custom
                    className='border'
                  >
                    <option value="Can't remember or don't want to say">
                      Can&apos;t remember or don&apos;t want to say
                    </option>
                    <option value='Someone I know'>Someone I know</option>
                    <option value='Search Engine'>Google / Bing / Other search engine</option>
                    <option value='Facebook / Social Media'>Facebook / Social Media</option>
                    <option value='Leaflet'>Leaflet</option>
                    <option value='Enquiry at other premises'>
                      Enquiry at sport&apos;s premises
                    </option>
                    <option value='Another Organisation'>Another organisation</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col sm='12' lg='6'>
                <Form.Group controlId='MarketingConsent'>
                  <Form.Label>May we send you non-essential marketing emails?</Form.Label>
                  <Form.Control
                    as='select'
                    value={marketingConsent}
                    onChange={(e) => setMarketingConsent(e.target.value)}
                    custom
                    className='border'
                  >
                    <option value='No'>No, Thank You.</option>
                    <option value='Yes'>Yes please.</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm='12' className='text-center mt-4 mb-2'>
                {props.submitClicked || props.errorMessage !== "" ? (
                  <Button
                    variant='success'
                    className='w-100 mt-2 mb-2 text-center '
                    type='button'
                    disabled
                  >
                    Processing...
                  </Button>
                ) : (
                  <Button variant='success' className='w-100 mt-2 mb-2 text-center ' type='submit'>
                    Save <MdSave />
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        </Col>
        <div className='mt-2 mb-2'>
          <StatusBlock
            errorMessage={props.errorMessage}
            successMessage={props.successMessage}
            dismissMessages={props.dismissMessages}
          />
        </div>
      </Row>
    </FadeIn>
  );
};

export default EditYourInfo;
